<template>
  <div class="question-wrap">
		<div class="top_img_wrap">
			<img class="main" :src="isSupportWebp('https://images.yifucj.com/topic/2021/06/30/f909f992-c578-4ee3-a10a-a93980cfcdf4.jpg')" />
		</div>
		<div class="content_wrap main clearfix">
			<!--问答左侧-->
			<div class="content-left left">
				<div class="nav_wrap">
          <nuxt-link :class="{ active: !$route.params.t }" to="/question">全部问答</nuxt-link>
          <nuxt-link :class="{ active: $route.params.t === 'pay' }" to="/question/pay">付费问答</nuxt-link>
          <nuxt-link :class="{ active: $route.params.t === 'free' }" to="/question/free">免费问答</nuxt-link>
          <nuxt-link :to="authUser ? '/user/question' : '/login'">我的问答<span v-show="waitNum > 0">{{ waitNum }}</span></nuxt-link>
				</div>
				<div class="content_detail">
					<div class="class_wrap">
            <template v-if="$route.params.t === 'my' && authUser">
              <!-- 我的问答（老师） -->
              <div v-if="authUser.type === 1" class="teacher_change_price">
          			<p v-if="price === -1">您当前暂未开通问答功能，请点击右侧设置按钮开通<button type="button" @click="handleSetPrice">设置</button></p>
          			<p v-else>您当前设置的问答价格为：<span>{{ price }}</span> G币/次<button type="button" @click="handleSetPrice">修改</button></p>
          		</div>
              <!-- 我的问答（学生） -->
          		<div v-else class="user_my yf-text_12">
                <nuxt-link :class="{ active: !$route.query.type }" to="/question/my">我的提问</nuxt-link>
                <nuxt-link :class="{ active: $route.query.type*1 === 2 }" to="/question/my?type=2">我解锁的</nuxt-link>
          		</div>
            </template>
            <!-- 问答数据 -->
            <div v-if="!list.length" style="text-align: center; line-height: 100px; color: #666;">暂无数据</div>
            <template v-else>
              <y-item v-for="item in list" :data="item" :key="item.id"></y-item>
            </template>
            <!--分页-->
            <y-pager :total="total"></y-pager>
					</div>
				</div>
			</div>
			<!--问答右侧-->
			<div class="content-right right">
        <p class="ask-btn pay_question" @click="handleAsk(1)">付费问</p>
        <p class="ask-btn free_question" @click="handleAsk(0)">免费问</p>
				<!--推荐位-->
				<ul class="right_recommend">
					<li class="item" v-for="item in $store.state.adList['payPaperTeacher']" :key="item.id">
						<div class="item_top clearfix">
							<section class="img_wrap left">
								<nuxt-link :to="`/question/list/${item.relationData.id}`">
                  <img v-lazy="isSupportWebp(item.relationData.avatar)" :alt="item.relationData.userName" />
                </nuxt-link>
							</section>
							<section class="text_wrap left">
                <div class="text_wrap-info clearfix">
                  <p class="name left">
                    <nuxt-link class="inline ellipsis" :to="`/question/list/${item.relationData.id}`">{{ item.relationData.userName }}</nuxt-link>
                  </p>
                  <p class="answer_num right">
                    已回答<span> {{ item.relationData.questionAnswerTotal }}</span>
                  </p>
                </div>
								<div class="text_wrap-sign ellipsis">{{ item.relationData.sign }}</div>
							</section>
						</div>
						<div class="item_bottom clearfix">
							<p class="left"><span>{{ item.relationData.questionPrice }}</span> G币/次</p>
              <button type="button" class="right btn-ask" @click="handleAsk(item.relationData)">立即提问</button>
						</div>
					</li>
				</ul>
				<!--30日排行榜-->
				<ul class="right_recommend">
					<p class="paihang_wrap"><img src="~assets/question_paihang.png" alt="问答排行"><span>30日问答排行榜</span></p>
					<li class="item" v-for="item in $store.state.adList['rankPaperTeacher']" :key="item.id">
						<div class="item_top clearfix">
							<section class="img_wrap left">
								<nuxt-link :to="`/question/list/${item.relationData.id}`">
                  <img v-lazy="isSupportWebp(item.relationData.avatar)" :alt="item.relationData.userName" />
                </nuxt-link>
							</section>
							<section class="text_wrap left">
                <div class="text_wrap-info clearfix">
                  <p class="name left">
                    <nuxt-link class="inline ellipsis" :to="`/question/list/${item.relationData.id}`">{{ item.relationData.userName }}</nuxt-link>
                  </p>
                  <p class="answer_num right">
                    已回答<span> {{ item.relationData.questionAnswerTotal }}</span>
                  </p>
                </div>
								<div class="text_wrap-sign ellipsis">{{ item.relationData.sign }}</div>
							</section>
						</div>
						<div class="item_bottom clearfix">
							<p class="left"><span>{{ item.relationData.questionPrice }}</span> G币/次</p>
              <button type="button" class="right btn-ask" @click="handleAsk(item.relationData)">立即提问</button>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import Dialog from '@/utils/Dialog'
import Webp from '@/mixins/Webp'
import YItem from '@/components/question/Item'

export default {
  mixins: [Webp],
  name: 'question-index',
  watchQuery: ['page', 'num', 't'],
  validate ({ params }) {
    return !params.t || params.t === 'pay' || params.t === 'free'
  },
  async asyncData ({ params, query, $axios }) {
    // loading main data from query
    let apiParams = {
      page: query.page || 1,
      num: query.num || process.env.DEFAULT_PAGE_SIZE,
    }
    switch (params.t) {
      case 'pay':
        apiParams.pay = 1
        break
      case 'free':
        apiParams.pay = 2
        break
    }
    let data = await $axios._get('Ask/List', apiParams)
    // console.log(data)
    return {
      list: data ? data.list : [],
      total: data ? data.totalCount : 0
    }
  },
  head () {
    return {
      title: '问答_一富财经_投资教育平台_股票问答_股票交流',
      meta: [
        { hid: 'keywords', name: 'keywords', content: '股票问答_股票解答_股票咨询_股票分析_个股诊断_股票行情_大盘走势' },
      ]
    }
  },
	data () {
		return {
      price: -1
		}
  },
  mounted () {
    // 如果是老师，初始化问答价格
    if (this.isTeacher) {
      this.$axios._get('/Teacher/Info', { id: this.authUser.id }).then(resp => {
        this.price = resp.questionPrice
      })
    }
    // 获取广告位数据
    this.$store.dispatch('getAd', ['rankPaperTeacher', 'payPaperTeacher'])
  },
	methods: {
    handleAsk (type) {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      // 老师身份不能问别人问题
      if (this.isTeacher) {
        Dialog.alert('您是尊贵的老师身份，目前暂时还不支持老师向老师提问哦~~')
        return
      }
      if (type === 0) {
        this.$store.dispatch('getAd', ['freePaperTeacher']).then(() => {
          Dialog.ask(type)
        })
      } else {
        Dialog.ask(type)
      }
     
    },
    // 设置/修改提问价格
    handleSetPrice () {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      Dialog.prompt('请输入您想设置的价格：', '设置价格', {
        inputPattern: /^\d+$/,                // 设置输入值必须匹配为数字
        inputPlaceholder: '输入值必须为数字',  // 输入框placeholder
        inputErrorMessage: '不合法的输入值'    // 警告信息
      }).then(({ value }) => {
        this.$axios._post('/Teacher/QuestionPrice', { price: value }).then(res => {
          this.price = value
          this.$notify({
            title: '成功',
            message: '价格修改成功',
            type: 'success'
          })
        })
      })
    }
  },
	computed: {
    ...mapState('user', {
      waitNum: state => state.ask.wait,
      authUser: state => state.data
    }),
    isTeacher () {
      return this.$store.getters['user/isTeacher']
    }
	},
	components: {
    YItem
	}
}
</script>
